import api from "../../../utils/api";

// module audit
export const getAuditByModule = async (module) => {
  const res = await api.get(`/audit/module/${module}`);
  return res.data.data;  // return only the array of logs
};

// project audit
export const getAuditByProject = async (projectId) => {
  const res = await api.get(`/audit/project/${projectId}`);
  return res.data.data;
};

// user audit
export const getAuditByUser = async (userId) => {
  const res = await api.get(`/audit/user/${userId}`);
  return res.data.data;
};